import React, {Component} from 'react';
import ReactTable from 'react-table';
import FontAwesome from 'react-fontawesome';
import firebase from 'firebase/app';
import 'firebase/firestore';
import 'firebase/storage';
import moment from 'moment';

/** @class ShowReleases
  * A component that lists releases for a virtual expo show.
  */
export default class ShowReleases extends Component {
  /** @constructor
    * Creates a new instance of ShowReleases
    */
  constructor(props) {
    super(props);
    this.state = {}
    this.buildRelease = this.buildRelease.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleRemove = this.handleRemove.bind(this);
    const uriParts = this.props.dataURL.split('/')
    this.expoID = uriParts[2];
    this.showID = uriParts[4];
    this.query = firebase.firestore()
      // expo
      .collection('expos').doc(this.expoID)
      // show
      .collection('shows').doc(this.showID)
  }
  /** @method componentWillMount
    * Connects the component to the firestore database
    */
  componentWillMount() {
    // Listen for current
    this.removeCurrentObserver = this.query
      .onSnapshot(snapshot => {
        if(snapshot.exists) {
          var doc = snapshot.data();
          this.setState({currentReleaseID: doc.current});
        }
      });
    // Listen for releases
    this.removeReleaseObserver = this.query
      .collection('releases')
        .onSnapshot(snapshot =>  {
        var releases = []
        snapshot.forEach(doc => {
          const release = doc.data();
          release.id = doc.id;
          releases.push(release);
        });
        this.setState({releases: releases});
      });
  }
  /** @method componentWillUnmount
    * Releases the connection to the firestore database
    */
  componentWillUnmount() {
    this.removeReleaseObserver();
    this.removeCurrentObserver();
  }
  /** @method buildRelease
    * Builds a new release from the current state of the show
    * in the editor.
    */
  buildRelease() {
    alert("Building a new release.  This process will take some time.  You may navigate away from this page.  However, any changes made to the show until the build finishes may or may not be included in the show");
    // TODO: need to use firebase functions to build release
    this.query.collection('releases').add({
      status: 'Compiling',
      builtAt: moment().format()
    })
  }
  /** @method handleChange
    * Sets a release to be the current release.
    * @param {Event} event - the inciting event
    */
  handleChange(event) {
    // Get the current release
    const release = this.state.releases.find((release) => {
      return release.id === event.target.value
    });
    // Make sure the release status is "Complete"
    if(release.status !== "Complete") {
      alert("Only releases with the status of 'Complete' can be made the current release");
      return;
    }
    this.query.set({current: event.target.value});
  }
  /** @method handleRemove
    * Removes the specified release from the firestore database
    * and removes its assets from storage.
    * @param {string} id - The identifier of the release to delete
    */
  handleRemove(id) {
    // Make sure we aren't removing the current release
    if(id === this.state.currentReleaseID) {
      alert("You cannot remove the current release, as this would take down a live show.  Switch to a different release, and then delete");
      return;
    }
    // Delete the selected release and its assets
    this.query.collection('releases').doc(id).delete()
    .then(() => {
      // TODO: Need to use firebase functions + cloud storage to delete assets
    })
  }
  /** @method render
    * Renders the component
    */
  render() {
    const columns = [
      {Header: 'Current?', accessor: 'id', Cell: (row) => (
        <div className="centered-text">
          <input name="current"
            type="radio"
            value={row.value}
            checked={row.value === this.state.currentReleaseID}
            onChange={this.handleChange}
            />
        </div>
      )},
      {Header: 'Name', accessor: 'name'},
      {Header: 'Built', accessor: 'builtAt', Cell: (row) => (
        (row.value) ? moment(row.value).format('M/D/YYYY h:MM A') : ''
      )},
      {Header: 'Status', accessor: 'status'},
      {Header: 'ID', accessor: 'id'},
      {Header: 'Delete', accessor: 'id', Cell: (row) => (
        <div className="centered-text">
          <FontAwesome name="times"
            style={{color: 'red', cursor: 'pointer'}}
            onClick={()=>this.handleRemove(row.value)}/>
        </div>
      )}
    ]
    return (
      <div>
        <p className="info-panel">
          This table lists all existing releases of the
          show.  The entry marked "current" is the version
          that is currently reachable online at the Expo
          host address. If you change the current release,
          all show visitors will see the newly selected
          release the next time they log into or refesh
          thier currently opened show page.
        </p>
        <button className="btn btn-success" onClick={this.buildRelease}>
          <FontAwesome name="release"/>
          Build Release
        </button>
        <ReactTable
          data={this.state.releases}
          columns={columns}
          defaultPageSize={10}
          defaultSorted={[{id: "builtAt", desc: true}]}
          />
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/show-editor/show-releases.js